import Vue from "vue";
import {
  Icon,
  Toast,
  DropdownMenu,
  DropdownItem,
  Search,
  Loading,
} from "@digitalgd/yzy-ui";

Vue.use(Search);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Loading);
